import * as z from 'zod';
import { ContractSuretyType } from '../../../../../enums.mjs';
import { Get as Get$1 } from './contract-surety-quote-preview.dto.mixins.mjs';

var Get;
(function (Get) {
    (function (Response) {
        Response.schema = Get$1.Response.baseSchema(ContractSuretyType.final).extend({
            contractSuretyType: z.literal(ContractSuretyType.final),
        });
    })(Get.Response || (Get.Response = {}));
})(Get || (Get = {}));

export { Get };
